<template>
  <div>
    <div v-if="attachments && attachments.length === 1" @click.stop="changeLocation(resource, attachments[0]);" class="in-locations">In 1 location</div>
    <Popover v-if="attachments && attachments.length > 1" placement="bottom" :width="150">
      <div class="in-locations no-select" @click.stop=";">In {{attachments.length}} locations</div>
      <div slot="content">
        <div class="locations">
          <slot v-for="(att, index) in attachments">
            <div :key="resource._id + '-' + att._id" @click="changeLocation(resource, att);" class="list-item no-select">
              Location {{index+1}}
            </div>
          </slot>
        </div>
      </div>
    </Popover>
  </div>
</template>

<script>
import utils from '@/utils/utils.js';
import bookUtils from '@/utils/bookUtils.js';
import Popover from '@/components/widgets/popover';

export default {
  name: 'InLocations',
  components: {
    Popover
  },
  props: {
    resource: {
      type: Object,
      required: true
    },
    attachments: {
      type: Array,
      required: true
    },
    book: {
      type: Object,
      required: true
    },
    bookMetadata: {
      type: Object
    },
    onCurrentPageChanged: {
      type: Function
    },
    close: {
      type: Function
    }
  },
  data: function() {
    return {
      
    }
  },
  methods: {
    changeLocation(resource, attachment) {
      var page = 1;
      if(this.bookMetadata && this.bookMetadata.pages) {
        page = bookUtils.getPageFromFile(this.bookMetadata, attachment.section, this.book.format);
        if (bookUtils.isPDF(this.book)) {
          this.onCurrentPageChanged(page, 'inLocation');
          this.close();
        } else {
          this.$router.push(utils.getBookLink(this.book, page));
          this.close();
        }
      } else {
        this.$router.push(utils.getBookLink(this.book, "null") + "?section=" + attachment.section);
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";
.in-locations {
  color: $primary-color;
  font-size: 11pt;
  cursor: pointer;
}

.in-locations:hover {
  color: $background-color-darkest;
  text-decoration: underline;
}

.locations {
  .list-item {
    padding: 10px;
  }
}
</style>